import { gql } from '@apollo/client';

export const UPDATE_REGISTER_LOG_COMMENT = gql`
  mutation updateRegisterLogComment($input: RegisterLogCommentInput!) {
    updateRegisterLogComment(input: $input) {
      status
      message
    }
  }
`;

export const UPDATE_REGISTER_APPROVAL_STATUS = gql`
  mutation updateRegisterApprovalStatus($input: RegisterApprovalStatusInput!) {
    updateRegisterApprovalStatus(input: $input) {
      status
      message
      data {
        id
        status
      }
    }
  }
`;

export const UPDATE_REGISTER_LOG_APPROVAL = gql`
  mutation UpdateRegisterLogApproval(
    $registerLogId: ID!
    $data: UpdateRegisterLogApprovalInput!
  ) {
    updateRegisterLogApproval(registerLogId: $registerLogId, data: $data) {
      status
      message
    }
  }
`;
